<div class="OlivorStore">
  <section class="OlivorbannerBg" fxLayout="row">
        <div fxFlex="50" fxLayout="row" fxLayoutAlign="center">
        <div>
                    <h3>Come Visit our Butcher Shop located at 341 Sydney Washer Road Dover Fl 33527</h3>
                    <h2>Our Family Raising Healthy Food For Yours <strong style="color: #ffe680;">!</strong></h2>
                    <h5>No Vaccines, No Antibiotics, No confinement, No Antibiotics Ever!!!</h5>
                    <button routerLink="/shop">order now ♡</button>
        </div>
        </div>
        <div fxFlex="50"></div>
  </section>
  <section class="OlivorstoreTimeInfo">
        <div class="container">
              <div class="row">
                    <div class="col-md-12">
                          <div>
                                <p>IF this <strong>is your first order with us, please read over our Home delivery and pick up info page or the CSA info page , whichever applies. Thank you for your support!!</strong></p>
                                <p>Our current store hours are Tuesday 10-5, Thursday <strong>1-5</strong> and <strong>Friday</strong> and <strong>Saturday 10-5</strong>.</p>
                                <div class="delveryIn">
                                      <a href="#">HOME DELIVERY AND PICK UP INFO PAGE</a>
                                      <a href="#">CSA BOX INFORMATION</a>
                                </div>
                          </div>
                    </div>
              </div>
        </div>
  </section>
  <section class="OlivorFeaturedItems">
        <div class="container">
              <div class="SectionHeder">
                    <h2>Featured Items</h2>
                    <p>Try one of our signature selections and see what everyone's talking about</p>
              </div>
              <div class="row OlivorFeaturedItem">
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>CSA Meat Box Small please read description</h4>
                                      <p>Price is for 3 boxes not per box. 3 month minimum Subscription. Can be cancelled anytime after 3...</p>
                                      <span>$329.99 - $409.99</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p213_i1_w1920.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>1/4 Beef Box Please allow 2 -3 weeks pick up only</h4>
                                      <p>Approximately 100 lb of Grass Fed beef representing cuts from the front and back half of...</p>
                                      <span>$1,499.99</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p99_i1_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Hog Butchery Workshops</h4>
                                      <p>Join our Hog Butchery Workshops and learn the art of butchering from our expert instructors. With...</p>
                                      <span>$150.00</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p466_i2_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Whole Non GMO Turkey Deposit Turkeys are pick up only we can’t deliver them</h4>
                                      <p>Pasture Raised Turkey. Will be Fresh Frozen pick up at Farm only. Deposits are NON...</p>
                                      <span>$25.00 - $50.00</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p63_i2_w1080.png?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Picnic Ham Smoked Thanksgiving(Read Description)</h4>
                                      <p>Billed at $13.99 lb at pick up in the balance after depositUncured Smoked Bone in Picnic Ham...</p>
                                      <span>$25.00</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p325_i2_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>15 Olives Robust Extra Virgin Florida Olive Oil</h4>
                                      <p>Chef Joe’s made from Scratch Char Siu marinade made withHoisin, Liquid Aminos, Honey, Sherry...</p>
                                      <span>$19.99</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p324_i3_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Dancing Narwhal Whipped Tallow Balm</h4>
                                      <p>Citrusy Smelling Natural Deodorant made by Soap Me locally</p>
                                      <span>$14.99</span>
                                </div>
                                <div>
                                <!-- <img src="" alt="">    -->
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Bourbon Infused Red Balsamic Vinegar</h4>
                                      <p>8 Fluid ouncesIngredients: Sour Orange juice, Pineapple Juice, Lemon Juice, Kosher Salt, Garlic...</p>
                                      <span>$19.99</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p324_i3_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
              </div>
              <div class="centerContent">
                    <button class="bgDarkBrown">order now ♡</button>
              </div>
        </div>
  </section>
  <section class="OlivorFeaturedCategories">
        <h2>Featured Categories</h2>
  </section>
  <section class="OlivorFeaturedCategoriesItem">
  <div class="container">
              <div class="row">
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c2_i3_w1440.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>Charcuterie  and Ferments</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c3_i2_w1701.png?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>CSA BOXES AND MONTHLY...</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c4_i1_w5287.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>MEATS</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c13_i1_w4719.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>PASTURED EGGS</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c14_i3_w1771.png?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>PASTURED NON GMO TURKEY</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c15_i1_w2048.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>WILD CAUGHT SEAFOOD</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c25_i3_w3024.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>Pre Marinated Meats and Party Packs</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c26_i1_w5587.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>HONEY, OILS, MARINADES AND SAUCES...</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c28_i3_w440.jpeg?dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>PET FOOD AND TREATS</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c31_i1_w1439.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>Workshops and Classes</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c33_i1_w699.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>Bakery</h5>
                                </div>
                          </div>
                    </div>
                    <div class="col-lg-4 rowCate">
                          <div>
                                <div class="cateImg">
                                      <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_c34_i1_w1440.jpeg?width=640&dpr=1" alt="">
                                </div>
                                <div>
                                      <h5>Soaps and Home Essentials</h5>
                                </div>
                          </div>
                    </div>
              </div>
  </div>
  </section>
  <section class="OlivorFeaturedItems bglightGray">
        <div class="container">
              <div class="SectionHeder">
                    <h2>New Arrivals</h2>
              </div>
              <div class="row OlivorFeaturedItem">
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Local Pig Liver</h4>
                                      <p>Local whole roaster pig.</p>
                                      <span>$6.99</span>
                                </div>
                                <div>
                                <!-- <img src="" alt="">    -->
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Char Siu Chicken Wings 2 lb</h4>
                                      <p>OHF non-GMO chicken wings marinated in hoisin liquid amino‘s honey sherry wine garlic crushed...</p>
                                      <span>$21.99</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p402_i1_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Pre Marinated Breast Sampler 4 pack</h4>
                                      <p>A 4 pack of Chef Joe’s Pre Marinated OHF chicken breasts. You will get 1- 12 Oz pack of each of the...</p>
                                      <span>$150.00</span>
                                </div>
                                <div>
                                <img src="" alt="">   
                                </div>
                          </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-6">
                          <div fxLayout="row" fxLayoutAlign="start space-between" fxLayoutGap="15px">
                                <div fxFlex="auto">
                                      <h4>Guanciale Sliced</h4>
                                      <!-- <p></p> -->
                                      <span>$6.99</span>
                                </div>
                                <div>
                                <img src="https://131069381.cdn6.editmysite.com/uploads/1/3/1/0/131069381/s274913209325712685_p380_i1_w2880.jpeg?width=160&optimize=medium" alt="">   
                                </div>
                          </div>
                    </div>
              </div>
              <div class="centerContent">
                    <button class="bgDarkBrown">order now ♡</button>
              </div>
        </div>
  </section>
  <section class="oliverOurFamily">
        <div class="container">
              <div class="row">
                    <div class="col-md-6">
                          <img class="img-responsive" src="https://86aa7c07e174f7ad0490.cdn6.editmysite.com/uploads/b/86aa7c07e174f7ad04906b85a9253c60957511031fd8f276b491ce5170cbe126/Screenshot_17_1597920415.png?width=2400&optimize=medium" alt="">
                    </div>
                    <div class="col-md-6">
                          <h2>From <span>our family</span> to yours ♡</h2>
                          <p>My name is John Roberts. My wife Chrysti and i have been making changes to our diet to be healthier for our grandchildren. Olivor is a combination of our grandsons' names Oliver and Ivor. We wanted them to grow up knowing where their food came from and how to raise it naturally.</p>
                          <p>Think about it, in today's world how many people can actually feed themselves without buying food. Actually being able to raise enough food to feed your family and have surplus to sell to others is a powerful thing, at the most basic level of living.</p>
                          <h6>We must all eat to live!</h6>
                    </div>
              </div>
        </div>
  </section>
  <section class="oliverFarmStore">
        <div class="container">
              <div class="row">
                    <div class="col-md-12">
                          <div class="jumbotron">
                                <h1>Check Out Our Farm Store!</h1>
                                <p>Our Farm Store located at <b>341 Sydney Washer Road Dover, Florida 33527</b> Open Thursday 1-5, Friday and Saturday 10-5. Tuesday Wednesday by appointment.</p>
                                <p>Come and check out our large assortment local Pasture Raised Non Gmo meats We love what we do and we know you will love it to!</p>
                                <div class="centerContent">
                                      <button class="btn btn-default">THE FARM STORE ♡</button>
                                </div>
                          </div>
                    </div>
              </div>
        </div>
  </section>
  <section class="oliverOurProcess">
        <div class="container">
              <div class="row">
                    <div class="col-md-12">
                          <h1>Olivor Heritage Our Process</h1>
                          <p>Get first peek at the behind-the-scenes making of our products.</p>
                          <iframe src="https://www.youtube.com/embed/6ibl-gL4F20?si=obaUKLR1PDtyz6WP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
              </div>
        </div>
  </section>
  <section class="oliverStoreMap">
        <div class="container">
              <div class="row">
                    <div class="col-md-12 gmap">
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28197.272469948955!2d-82.2233240652344!3d27.94309549999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dd33261324a7a7%3A0xd87aeaf65de5a137!2s341%20Sydney%20Washer%20Rd%2C%20Dover%2C%20FL%2033527%2C%20USA!5e0!3m2!1sen!2sin!4v1721622190611!5m2!1sen!2sin" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div class="col-md-4">
                          <h4>Dover Farm Store</h4>
                    </div>
                    <div class="col-md-4">
                          <address>
                                <ul class="list-unstyled">
                                      <li>341 Sydney Washer Road</li>
                                      <li>Dover, 33527, US</li>
                                      <li>(813) 494-6751</li>
                                      <li>john@olivorheritagefarms.com</li>
                                      <li><a href="#">Get directions</a></li>
                                </ul>
                          </address>
                    </div>
                    <div class="col-md-4">
                          <ul class="list-unstyled">
                                <li>Monday Closed</li>
                                <li>Tuesday 10:00 am- 5 pm</li>
                                <li>Wednesday Closed</li>
                                <li>Thursday 1:00 pm - 5:00pm</li>
                                <li>Friday 10:00 am - 5:00pm</li>
                                <li>Saturday 10:00am - 5:00pm</li>
                                <li>Sunday Closed</li>
                          </ul>
                    </div>
              </div>
        </div>
  </section>
  <section class="oliverContactus" id="contact-us">
        <div class="container">
              <div class="row">
                    <div class="col-md-12">
                          <h2>Contact us</h2>
                          <p>We're happy to answer questions or help you with returns. Please fill out the form below if you need assistance.</p>
                          <form>
                                <div class="form-group">
                                      <input type="text" class="form-control" placeholder="Full name" required>
                                </div>
                                <div class="form-group">
                                      <input type="tel" class="form-control" placeholder="Phone number">
                                </div>
                                <div class="form-group">
                                      <input type="tel" class="form-control" placeholder="Email" required>
                                </div>
                                <div class="form-group">
                                      <input type="text" class="form-control" placeholder="Order number">
                                </div>
                                <div class="form-group">
                                      <input type="text" class="form-control" placeholder="Company name">
                                </div>
                                <div class="form-group">
                                      <input type="text" class="form-control" placeholder="RMA Number">
                                </div>
                                <div class="form-group">
                                      <textarea name="comments" id="comments" class="form-control" required placeholder="Comments/Questions"></textarea>
                                </div>
                                <div>
                                      <p>You may receive marketing and promotional materials. Contact the merchant for their privacy practices.</p>
                                      <p class="ligtText">This form is protected by reCAPTCHA and the Google <a href="#">Privacy Policy</a> and <a href="#">Terms of Service apply</a>.
                                      </p>
                                </div>
                                <div>
                                      <button class="btn btn-default">Submit</button>
                                </div>
                          </form>
                    </div>
              </div>
        </div>
  </section>
  <section class="oliverNewsletter">
        <div class="container">
              <div class="row">
                    <div class="col-md-12">
                          <h3>Stay in the Loop</h3>
                          <div class="signupCtrl" fxLayout="row" fxLayoutAlign="start">
                                <input class="form-control" type="email" placeholder="Email" fxFlex="auto">
                                <button>Sign Up</button>
                          </div>
                          <p class="ligtText">This form is protected by reCAPTCHA and the Google <a href="#">Privacy Policy</a> and <a href="#">Terms of Service apply</a>.
                    </div>
              </div>
        </div>
  </section>
</div>